import type {IConsentItem} from "../types/financial_application";

const RODO_CONSENT_TEMPLATE_ID = "01KRNND9GX2B31A1WS6XX715Z4";

export const rpFinancialApplicationConsents: IConsentItem[] = [
    {
        consent_template_id: RODO_CONSENT_TEMPLATE_ID,
        state: true
    }
];
import type {IConsentItem} from "../types/financial_application";

const RODO_CONSENT_TEMPLATE_ID = "01KRNND9GX2B31A1WS6XX715Z4";

export const rpFinancialApplicationConsents: IConsentItem[] = [
    {
        consent_template_id: RODO_CONSENT_TEMPLATE_ID,
        state: true
    }
];
